import { P } from 'ia-react-core';
import styled from 'styled-components';

export const StyledP = styled(P)`
  line-height: 1.29;
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const StyledLink = styled.span`
  > a & {
    font-weight: 600;

    :hover {
      text-decoration: underline;
    }
    :active {
      color: ${({ theme }) => theme.colors.blue10};
      text-decoration: underline;
    }
  }
`;
